import PaymentSection from './components/PaymentSection';
import FAQSection from './components/FAQSection';

export default function PaymentPage() {
  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-amber-400/20 backdrop-blur-sm rounded-full mb-6 border-2 border-amber-400/30">
            <i className="ri-bank-card-line text-4xl text-amber-400"></i>
          </div>
          <h1 className="text-5xl font-bold mb-6">
            Paga Tu Deuda <span className="text-amber-400">en Línea</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Realiza el pago de tu deuda de forma rápida, segura y desde cualquier lugar
          </p>
        </div>
      </section>

      <PaymentSection />
      <FAQSection />
    </div>
  );
}
